import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { Button } from "../button";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { KIOSK_CHECK_IN_FLOW } from "../../constants/common";
import { useUpdateKioskCheckInFlowConfig } from "../../hooks/common/mutation";
import { useGetKioskCheckInFlowConfig } from "../../hooks/common/query";
import Loader from "../loader";

const KioskCheckInFlowConfigurationsCard = () => {
  const { t, i18n } = useTranslation();

  const { data: kioskCheckInFlow, isLoading: isGetKioskCheckInFlowConfigLoading } = useGetKioskCheckInFlowConfig();
  const { mutateAsync: UpdateKioskCheckInFlowConfig, isPending: isUpdateKioskCheckInFlowConfigLoading } = useUpdateKioskCheckInFlowConfig();

  const [kioskMode, setKioskMode] = useState<number>(KIOSK_CHECK_IN_FLOW.BOTH_QR_FACIAL_SCAN);

  const { handleSubmit } = useForm();

  const options: { value: number; label: string }[] = [
    { value: KIOSK_CHECK_IN_FLOW.ONLY_QR_CODE_SCAN, label: t("onlyQRCodeScan") },
    { value: KIOSK_CHECK_IN_FLOW.ONLY_FACIAL_SCAN, label: t("onlyFacialScan") },
    { value: KIOSK_CHECK_IN_FLOW.BOTH_QR_FACIAL_SCAN, label: t("bothQRFacialScan") },
  ];

  useEffect(() => {
    if (kioskCheckInFlow?.kioskCheckInFlow) {
      setKioskMode(Number(kioskCheckInFlow.kioskCheckInFlow));
    }
  }, [kioskCheckInFlow]);

  const onSubmit = () => {
    try {
      const body = {
        kioskCheckInFlow: String(kioskMode),
      }

      UpdateKioskCheckInFlowConfig(body);

      toast.success(t("kioskCheckInFlowUpdatedSuccessfully"));
    } catch {
      toast.error(t("somethingWentWrong"));
    }
  };

  return (
    <div className="flex flex-col gap-2 lg:gap-3">
      <h2 className="text-lg lg:text-xl font-medium">{t("kioskCheckInFlow")}</h2>

      {isGetKioskCheckInFlowConfigLoading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <RadioGroup.Root
            value={String(kioskMode)}
            onValueChange={(val) => setKioskMode(Number(val))}
            className="flex flex-col gap-3"
          >
            {options.map((option) => (
              <div dir={i18n.language === "en" ? "ltr" : "rtl"} key={option.value} className="flex items-center gap-2">
                <RadioGroup.Item
                  value={String(option.value)}
                  id={String(option.value)}
                  className="w-4 h-4 rounded-full border border-purple-primary flex items-center justify-center focus:outline-none"
                >
                  <RadioGroup.Indicator className="w-2 h-2 rounded-full bg-purple-primary" />
                </RadioGroup.Item>
                <label
                  htmlFor={String(option.value)}
                  className="text-sm cursor-pointer select-none"
                >
                  {option.label}
                </label>
              </div>
            ))}
          </RadioGroup.Root>

          <Button className="max-w-max !py-[14px] !px-9" isLoading={isUpdateKioskCheckInFlowConfigLoading}>
            {t("update")}
          </Button>
        </form>
      )}
    </div>
  );
};

export default React.memo(KioskCheckInFlowConfigurationsCard);
